import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  children: React.ReactNode;
  className?: string;
  'aria-label'?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  href,
  children,
  className = '',
  'aria-label': ariaLabel,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-red text-white hover:bg-red-800 focus:ring-brand-red',
    secondary: 'bg-transparent border-2 border-brand-blue text-brand-blue hover:bg-brand-blue hover:text-white focus:ring-brand-blue',
    ghost: 'bg-transparent text-navy-700 hover:bg-navy-100 hover:text-navy-900 focus:ring-navy-200'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-7 py-3 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    if (href.startsWith('http') || href.startsWith('#') || href.startsWith('mailto:')) {
      const isExternal = href.startsWith('http');
      return <a href={href} className={classes} aria-label={ariaLabel} {...isExternal ? {
        rel: 'noopener noreferrer'
      } : {}} data-id="element-37">
          {children}
        </a>;
    }
    return <Link to={href} className={classes} aria-label={ariaLabel} data-id="element-38">
        {children}
      </Link>;
  }
  return <button className={classes} aria-label={ariaLabel} {...props} data-id="element-39">
      {children}
    </button>;
}